module.exports = "https://static.web-purchase.prod.moonpig.net/_next/static/images/AppleLogo-a1994fbde0b299a4fc029f3239363122.svg";